import { Inbox } from "lucide-react";

export const EmptyState = ({ icon: Icon = Inbox, title, children, action }) => (
  <div data-testid="empty-state" className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border bg-cream/60 px-6 py-14 text-center">
    <div className="rounded-full bg-sage-light p-4">
      <Icon className="h-7 w-7 text-sage" aria-hidden />
    </div>
    <h3 className="mt-4 font-heading text-xl text-deepgreen">{title}</h3>
    {children && <p className="mt-2 max-w-md text-sm text-muted-foreground">{children}</p>}
    {action && <div className="mt-6">{action}</div>}
  </div>
);
